import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTES } from 'helpers/routes'
import ThumbUp from 'assets/images/onboarding/Thumbup.svg'
import { useProfile } from 'hooks/useProfile'
import './style.scss'
import { activateOnboardingStep, setOnboardingAnswers } from 'actions/assessment'

const choices = [
    { url: ROUTES.Home, text: 'Explore recommended resources' },
    { url: ROUTES.InHouseBenefits, text: 'Discover Accenture benefits' },
    { url: ROUTES.Search, text: 'Search for something specific' },
]
const Final = () => {
    const dispatch = useDispatch()
    const {
        appState: {
            onboardingAnswers: { postOnboardingNavigationChoice },
        },
    } = useSelector(state => state.assessment)

    const [postOnboardingChoice, setPostOnboardingChoice] = useState('')
    const { pilotTag } = useProfile()
    useEffect(() => {
        if (postOnboardingNavigationChoice) {
            setPostOnboardingChoice(postOnboardingNavigationChoice)
            dispatch(activateOnboardingStep({ number: 9, state: false }))
        }
    }, [postOnboardingNavigationChoice])

    const handleChoice = choice => {
        setPostOnboardingChoice(choice.url)
        dispatch(setOnboardingAnswers(choice.url, 'routeChoice'))
        dispatch(activateOnboardingStep({ number: 9, state: false }))
    }
    return (
        <div className="choicesContainer">
            <div className="choices">
                {choices.map((choice, index) =>
                    index === 1 ? (
                        pilotTag.toLowerCase() === 'accenture' && (
                            <div
                                key={index}
                                onClick={() => handleChoice(choice)}
                                style={postOnboardingChoice === choice.url ? { border: '2px solid black' } : {}}
                            >
                                <p style={postOnboardingChoice === choice.url ? { fontWeight: 700 } : {}}>{choice.text}</p>
                            </div>
                        )
                    ) : (
                        <div
                            key={index}
                            onClick={() => handleChoice(choice)}
                            style={postOnboardingChoice === choice.url ? { border: '2px solid black' } : {}}
                        >
                            <p style={postOnboardingChoice === choice.url ? { fontWeight: 700 } : {}}>{choice.text}</p>
                        </div>
                    )
                )}
            </div>
            <div style={{ padding: 16 }}>
                <img src={ThumbUp} alt="ThumbUp" />
            </div>
        </div>
    )
}

export default Final
